<template>
  <div class="space-y-6 part1">
    <div class="text-left space-y-2">
      <p class="text-2xl font-bold title">{{ item.name }}</p>
      <p class="text-sm text-gray-500 introduce">
        {{ item.intro }}
      </p>
    </div>
    <div class="flex space-x-24">
      <div>
        <p class="dollar">
<!--          <span class="dollar">{{ $p(item.price) }}</span>-->
          <span v-if="item.unitprice" class="flex is-center">{{ $p(item.unitprice) }}/{{$t("枝")}}<span class="single">{{$p(item.price)}}</span></span>
          <span v-else style="color: #FF4747 ">{{ $p(item.price) }}<span class="dollar" style="color: #333333;">{{ $t('/扎起') }}</span></span>
        </p>
      </div>

      <div>
        <p>
          <span class="tally sell">
            <span class="">{{ $t("已售") }}：{{ item.sales }}</span>
          </span>
        </p>
      </div>
    </div>

    <p class="space-x-30 text-left">
      <span class="count">
        {{ $t("数量") }}：
        <el-input-number
          size="small"
          v-model="num"
          @change="handleChange"
          :min="1"
          :max="item.stock"
        ></el-input-number>
      </span>

      <span class="store">{{ $t("库存") }}：{{ item.stock }}</span>

      <span class="total" v-if="user.id">
        {{ $t("合计") }}：
        <span class="text-red-500 font-bold text-xl">{{ $p(total) }}</span>
      </span>
    </p>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import bus from "@/API/util/bus.js";
export default {
  props: { item: Object },
  setup(props, ctx) {
    const num = ref(0);
    const handleChange = (val) => {
      bus.emit("changeCount", val);
    };

    const total = computed(() => num.value * props.item.price);
    const user = computed(() => ctx.root.$store.getters.user)

    return { handleChange, num, total, user };
  },
};
</script>

<style scoped lang="scss">
// @import "@/style/stl.scss";

// .count {
//   &::before {
//     content: " 数量：";
//   }
// }
// .store {
//   &::before {
//     content: " 库存：";
//   }
// }
// .total {
//   &::before {
//     content: "合计：";
//   }
// }
// .sell {
//   &::before {
//     content: "已售：";
//   }
// }
// .gt {
//   &::before {
//     content: "≥";
//   }
// }

.dollar {
  @apply text-red-500 font-bold text-lg;
}
.single {
  display: inline-block;
  height: 14px;
  padding: 0 5px 0 7px;
  font-size: 10px;
  line-height: 14px;
  color: #FFFFFF;
  margin-left: 4px;
  background-repeat: no-repeat;
  background-size: 100% 14px;
  background-image: url('https://cdn-qn.huaeb.com/sellmall/Uwm9/20240819/Ft3UvAmvjsKkwlIlBfinoTXmYQP6.png');

}
</style>
